<template lang="pug">
  div.lmm-content-body-padded
    router-view
</template>

<script>
export default {
  name: 'managers-component'
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
}
</style>
